function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.26,
    height: 11.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 5.855,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.71,
    width: 20.26,
    height: 14.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.808
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 18.73,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.75,
    width: 20.26,
    height: 14.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1142857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 33.15,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.55,
    width: 20.26,
    height: 14.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 47.949999999999996,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.35,
    width: 20.26,
    height: 14.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 62.84,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70.33,
    width: 20.26,
    height: 16.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 78.655,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.98,
    width: 20.26,
    height: 16.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.346
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 95.345,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.7,
    width: 20.26,
    height: 18.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6142857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 112.85000000000001,
    fontFamily: "Arial"
  }, "\n        Edwards\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122,
    width: 20.26,
    height: 18.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6357142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 131.225,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 140.45,
    width: 20.26,
    height: 20.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2511111111111113
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 150.58499999999998,
    fontFamily: "Arial"
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160.72,
    width: 20.26,
    height: 21.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 171.495,
    fontFamily: "Arial"
  }, "\n        Gallatin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.27,
    width: 20.26,
    height: 21.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 193.055,
    fontFamily: "Arial"
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.84,
    width: 20.26,
    height: 24.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0260000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 216.04,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 228.24,
    width: 20.26,
    height: 24.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2511111111111113
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 240.60500000000002,
    fontFamily: "Arial"
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.98,
    width: 20.26,
    height: 24.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8942857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 265.425,
    fontFamily: "Arial"
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.87,
    width: 20.26,
    height: 27.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 291.635,
    fontFamily: "Arial"
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.39,
    width: 20.26,
    height: 27.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 319.33,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 333.27,
    width: 20.26,
    height: 30.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 348.4,
    fontFamily: "Arial"
  }, "\n        Menard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.53,
    width: 20.26,
    height: 30.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 378.715,
    fontFamily: "Arial"
  }, "\n        Wabash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.91,
    width: 20.26,
    height: 32.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 410.21000000000004,
    fontFamily: "Arial"
  }, "\n        Ford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 426.5,
    width: 20.26,
    height: 32.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 442.95,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 459.41,
    width: 20.26,
    height: 32.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 475.88500000000005,
    fontFamily: "Arial"
  }, "\n        Moultrie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 492.36,
    width: 20.26,
    height: 33.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 508.98,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 525.6,
    width: 20.26,
    height: 33.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 542.255,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 558.91,
    width: 20.26,
    height: 33.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 575.795,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.68,
    width: 20.26,
    height: 35.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 610.305,
    fontFamily: "Arial"
  }, "\n        DeWitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.93,
    width: 20.26,
    height: 35.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 645.8649999999999,
    fontFamily: "Arial"
  }, "\n        Massac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.81,
    width: 20.26,
    height: 36.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.13,
    y: 681.905,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 0,
    width: 25.34,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.068
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.93,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 0,
    width: 25.41,
    height: 29.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.541
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.305,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 0,
    width: 26.26,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.13,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Bond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.26,
    y: 0,
    width: 26.44,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.48,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.7,
    y: 0,
    width: 26.9,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.15,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Piatt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.6,
    y: 0,
    width: 27.76,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9657142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.48,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.36,
    y: 0,
    width: 28.08,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.011428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.4,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.44,
    y: 0,
    width: 28.87,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.774
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.875,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.31,
    y: 0,
    width: 29.31,
    height: 29.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.846666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.965,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.62,
    y: 0,
    width: 30.51,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.846666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.875,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.13,
    y: 0,
    width: 31.34,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.8,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.46,
    y: 0,
    width: 31.53,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.22499999999997,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 0,
    width: 31.68,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.84,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.67,
    y: 0,
    width: 31.78,
    height: 29.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.56,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.46,
    y: 0,
    width: 32.01,
    height: 29.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.465,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.46,
    y: 0,
    width: 32.35,
    height: 29.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.846666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.635,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Jersey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.81,
    y: 0,
    width: 33.77,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.908
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.695,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Jo_Daviess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.58,
    y: 0,
    width: 34.66,
    height: 29.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.154285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.9100000000001,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.24,
    y: 0,
    width: 34.96,
    height: 29.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.72,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Edgar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.2,
    y: 0,
    width: 36.15,
    height: 29.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.2750000000001,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.36,
    y: 0,
    width: 37.25,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.846666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.985,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 662.6,
    y: 0,
    width: 37.4,
    height: 29.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.154285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.3000000000001,
    y: 14.54,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 29.08,
    width: 37.32,
    height: 31.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 44.705,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 60.32,
    width: 37.32,
    height: 32.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.462000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 76.475,
    fontFamily: "Arial"
  }, "\n        Boone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 92.64,
    width: 37.32,
    height: 35.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 110.625,
    fontFamily: "Arial"
  }, "\n        McDonough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 128.61,
    width: 37.32,
    height: 36.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 146.63500000000002,
    fontFamily: "Arial"
  }, "\n        Saline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 164.67,
    width: 37.32,
    height: 37.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 183.48,
    fontFamily: "Arial"
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 202.29,
    width: 37.32,
    height: 38.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 221.42,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 240.55,
    width: 37.32,
    height: 39.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 260.125,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 279.7,
    width: 37.32,
    height: 39.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.331428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 299.395,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 319.09,
    width: 37.32,
    height: 39.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 338.9,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 358.71,
    width: 37.32,
    height: 39.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 378.705,
    fontFamily: "Arial"
  }, "\n        Iroquois\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 398.7,
    width: 37.32,
    height: 40.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 419.08,
    fontFamily: "Arial"
  }, "\n        Woodford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 439.46,
    width: 37.32,
    height: 41.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 460.135,
    fontFamily: "Arial"
  }, "\n        Grundy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 480.81,
    width: 37.32,
    height: 42.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 502.245,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 523.68,
    width: 37.32,
    height: 43.44,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.331428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 545.4,
    fontFamily: "Arial"
  }, "\n        Kendall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 567.11,
    width: 37.32,
    height: 44.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 589.165,
    fontFamily: "Arial"
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 611.22,
    width: 37.32,
    height: 44.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 633.4,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.26,
    y: 655.58,
    width: 37.32,
    height: 44.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.92,
    y: 677.7900000000001,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 29.08,
    width: 35.53,
    height: 46.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.947777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.345,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Christian\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.11,
    y: 29.08,
    width: 37.08,
    height: 46.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.65,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.19,
    y: 29.08,
    width: 37.64,
    height: 46.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.273333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.01,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Bureau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.83,
    y: 29.08,
    width: 39.99,
    height: 46.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.82500000000002,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.82,
    y: 29.08,
    width: 40.04,
    height: 46.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.84,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Ogle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.86,
    y: 29.08,
    width: 43.24,
    height: 46.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.48,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.09,
    y: 29.08,
    width: 43.61,
    height: 46.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.361
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.895,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Stephenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.7,
    y: 29.08,
    width: 44.9,
    height: 46.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.15,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Coles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.6,
    y: 29.08,
    width: 48.76,
    height: 46.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.98,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.36,
    y: 29.08,
    width: 49.88,
    height: 46.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.83625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.3,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Macoupin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.24,
    y: 29.08,
    width: 53.05,
    height: 46.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.338
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.765,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.29,
    y: 29.08,
    width: 54.55,
    height: 46.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.5649999999999,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.85,
    y: 29.08,
    width: 56.31,
    height: 46.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.187777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.005,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Whiteside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.15,
    y: 29.08,
    width: 57.85,
    height: 46.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.669
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.0749999999999,
    y: 52.425,
    fontFamily: "Arial"
  }, "\n        Williamson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 75.77,
    width: 67.25,
    height: 46.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7749999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 99.095,
    fontFamily: "Arial"
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 122.42,
    width: 67.25,
    height: 47.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.495999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 146.16,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 169.9,
    width: 67.25,
    height: 56.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 197.92000000000002,
    fontFamily: "Arial"
  }, "\n        Vermilion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 225.94,
    width: 67.25,
    height: 57.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 254.51,
    fontFamily: "Arial"
  }, "\n        Kankakee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 283.08,
    width: 67.25,
    height: 71.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.607142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 318.76,
    fontFamily: "Arial"
  }, "\n        LaSalle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 354.44,
    width: 67.25,
    height: 79.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 393.985,
    fontFamily: "Arial"
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 433.53,
    width: 67.25,
    height: 79.13,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.208333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 473.09499999999997,
    fontFamily: "Arial"
  }, "\n        McLean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 512.66,
    width: 67.25,
    height: 85.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 555.5899999999999,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 598.52,
    width: 67.25,
    height: 101.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.472222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 91.205,
    y: 649.26,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.83,
    y: 75.77,
    width: 76.57,
    height: 91.94,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.938571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.115,
    y: 121.74,
    fontFamily: "Arial"
  }, "\n        McHenry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.39,
    y: 75.77,
    width: 79.37,
    height: 91.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.215454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.075,
    y: 121.74,
    fontFamily: "Arial"
  }, "\n        Rock_Island\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.77,
    y: 75.77,
    width: 85.6,
    height: 91.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.57,
    y: 121.74,
    fontFamily: "Arial"
  }, "\n        Peoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.37,
    y: 75.77,
    width: 103.34,
    height: 91.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.4925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.04,
    y: 121.74,
    fontFamily: "Arial"
  }, "\n        Sangamon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.71,
    y: 75.77,
    width: 113.75,
    height: 91.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.215555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.585,
    y: 121.74,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.46,
    y: 75.77,
    width: 116.54,
    height: 91.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.134285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.73,
    y: 121.74,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.83,
    y: 167.7,
    width: 102.69,
    height: 106.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.175,
    y: 220.995,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.83,
    y: 274.29,
    width: 102.69,
    height: 108.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.175,
    y: 328.40000000000003,
    fontFamily: "Arial"
  }, "\n        Kane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.83,
    y: 382.52,
    width: 102.69,
    height: 129.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.175,
    y: 447.265,
    fontFamily: "Arial"
  }, "\n        Will\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.83,
    y: 512.01,
    width: 102.69,
    height: 187.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.175,
    y: 606.005,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.52,
    y: 167.7,
    width: 472.48,
    height: 71.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.905000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.76,
    y: 203.415,
    fontFamily: "Arial"
  }, "\n        DuPage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.52,
    y: 239.14,
    width: 472.48,
    height: 460.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 115.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.76,
    y: 469.57,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.c824be183c600923f385e4e2811c874e.svg";
export { ForwardRef as ReactComponent };